export default __webpack_public_path__ + "alberta-erp.fec46690fda6bf2f749f.svg";